export var en = {
  ATTRIBUTES: 'Attributes',
  ATTRIBUTE_PLACEHOLDER: 'Select an attribute',
  CONDITIONAL: 'Conditional',
  CONDITIONAL_PLACEHOLDER: 'Select a condition',
  VALUE: 'Value',
  VALUE_PLACEHOLDER: 'Enter a value',
  TAG_PLACEHOLDER: 'Select a tag',
  VIEW_USERS_IN_SEGMENT: 'View users in segment',
  CLEAR_ALL: 'Clear all',
  ADD_RULE: 'Add rule',
  DELETE_ALL: 'Delete all',
  DATE: 'Date',
  SEARCH_PLACEHOLDER: 'Search...',
  NO_RESULTS: 'No results found',
  ERROR_FETCHING_VALUES: 'Error fetching attribute values'
};